// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2pMCa","tableContainer":"styles_tableContainer__1X3r3","rowsWrapper":"styles_rowsWrapper__10UmT","loader":"styles_loader__2D-TE"};